<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="8">
                    <b-card-group>
                        <b-card no-body class="p-4">
                            <b-card-body>
                                <h1>Reset password</h1>
                                <p class="text-muted">Enter new password </p>

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="icon-lock"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="password" v-model="$v.resetPasswordForm.newPassword.$model" class="form-control"
                                        placeholder="New password">
                                    </b-form-input>
                                </b-input-group>

                                <Feedback :state="validateRef('resetPasswordForm.newPassword')" invalid="This field is required, min length is 6"></Feedback>

                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="icon-lock"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="password" v-model="$v.resetPasswordForm.repeatedPassword.$model" class="form-control"
                                        placeholder="Repeat password">
                                    </b-form-input>
                                </b-input-group>

                                <Feedback :state="validateRef('resetPasswordForm.repeatedPassword')" invalid="This field is required and must equals new password"></Feedback>
                                <Feedback :state="resetError.state" :invalid="resetError.message"></Feedback>

                                <div v-if="passwordSuccessfullyChanged">
                                    <p class="text-success">Password changed successfully. <router-link to="/auth/login">Click here to log in.</router-link></p>
                                </div>

                                <b-row>
                                    <b-col cols="6">
                                        <b-button :disabled="$v.resetPasswordForm.$invalid" @click="resetPassword" variant="primary" class="px-4">Submit</b-button>
                                    </b-col>
                                </b-row>

                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {
    validationMixin
} from 'vuelidate'

import {
    required,
    sameAs,
    minLength
} from 'vuelidate/lib/validators'

import Feedback from '@/components/Feedback';

export default {
    data() {
        return {
            passwordSuccessfullyChanged: false,
            resetPasswordForm: {
                newPassword: null,
                repeatedPassword: null
            },
            resetError: {
                state: true,
                message: ''
            }
        }
    },
    mixins: [validationMixin],
    validations: {
      resetPasswordForm: {
        newPassword: {
            required,
            minLength: minLength(6)
        },
        repeatedPassword: {
            required,
            sameAsPassword: sameAs(function() {
                return this.resetPasswordForm.newPassword
            })
        }
      }
    },
    methods: {
      resetPassword() {
            const data = { newPassword: this.resetPasswordForm.newPassword, token: this.$route.query.token }
            this.axios.post(`${process.env.VUE_APP_NODE_API_HOST}/password/reset`, data).then(response => {
                this.passwordSuccessfullyChanged = true
                this.resetError.state = true;
            }).catch(exception => {
                this.resetError.state = false;
                if (exception.response.data.additionalInfo == "User not found") {
                    this.resetError.message = "Invalid token"
                } else {
                    this.resetError.message = exception.response.data.additionalInfo;
                }
            })
      },
      validateRef(ref) {
        const keys = ref.split('.');
        const validateField = keys.reduce((a, c) => {
          return a[c]
        }, this.$v);

        return validateField.$dirty ? !validateField.$invalid : null;
      }
    },
    components: {
      Feedback
    }
}
</script>